import raw from './line-colors.json';

/** The twelve lines of this snapshot (stable order). */
export const LINE_REFS = [
  'U70', 'U71', 'U72', 'U73', 'U75', 'U76', 'U77', 'U78', 'U79', 'U80', 'U81', 'U83',
] as const;

export type LineRef = (typeof LINE_REFS)[number];

/**
 * Central line-colour mapping (sRGB hex strings, keyed by line number).
 * The uniform blue GTFS source colour must not override this mapping.
 */
export const LINE_COLORS = raw as Record<LineRef, string>;

/** Fallback for unknown refs (should not happen for the twelve snapshot lines). */
export const FALLBACK_LINE_COLOR = '#ffffff';

export function lineColor(ref: string): string {
  const c = (LINE_COLORS as Record<string, string>)[ref];
  return c ?? FALLBACK_LINE_COLOR;
}
